import { Component } from 'react';
import {actions, Errors, Form} from 'forms/rrf';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import ErrorMessages from '../../login/error-messages';
import PageTitle from '../../common/page-title/index';
import ArrowButton from '../../common/button-arrow';
import RequiredPasswordMaskInput from '../../common/form/elements/required-password-mask-input';
import {adminUpdateMyPassword} from '../../../actions/update-password';

import './update-password.css';

class UpdatePassword extends Component {
  updateErrors = (field, value) => {
    this.setState({[field]: value});
  };
  onChangeMyPasswordClicked = (payload) => {
    this.props.dispatch(actions.submitFields('deep.updatePw.user', adminUpdateMyPassword(payload)));
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Form
        model="deep.updatePw.user"
        onSubmit={payload => this.onChangeMyPasswordClicked(payload)}
      >
        <Errors
          className="errors"
          component={ErrorMessages}
          model="deep.updatePw.user"
          show={{
            touched: true,
            focus: false
          }}
        />
        <Container fluid className="update-password">
          <Row>
            <Col lg={12}>
              <PageTitle>
                Update password
              </PageTitle>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <RequiredPasswordMaskInput
                controlId="currentPassword"
                label="Current Password"
                model=".current_password"
              />

              <h5>
                The password must be a minimum of 8 characters and contain one uppercase, one
                lowercase, one number and one symbol (e.g.@*&/).
              </h5>
              <RequiredPasswordMaskInput
                controlId="newPassword"
                label="New Password"
                model=".password"
              />

              <RequiredPasswordMaskInput
                controlId="confirmNewPassword"
                label="Confirm New Password"
                model=".password_confirmation"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ArrowButton
                arrow={false}
                className="float-end"
                color="red"
              >
                Change my password
              </ArrowButton>
            </Col>
          </Row>
        </Container>
      </Form>
    );
  }
}

export default connect()(UpdatePassword);
